/** Dynamic style helpers for values that depend on runtime data (pct, color). */
import type { WcColors } from './matchPickStats.helper';

/** Heat-map cell background: intensity 0→1 maps to primary color at 15%→100% opacity. */
export const heatMapCellStyle = (primaryColor: string, intensity: number) => {
  const alpha = Math.round((0.15 + intensity * 0.85) * 255)
    .toString(16)
    .padStart(2, '0');
  return { backgroundColor: `${primaryColor}${alpha}` } as const;
};

export const scorelineBarWidthStyle = (C: WcColors, pct: number, isTop: boolean) =>
  ({
    width: `${Math.round(pct * 100)}%` as `${number}%`,
    backgroundColor: isTop ? C.yellow : C.purple,
  }) as const;
